import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

const getAllLiveStatuses = async () => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.liveStatus.list);
    return data;
};

const GetAllLiveStatuses = () => {
    return useQuery(['LiveStatuses'], () => getAllLiveStatuses());
};

const addLiveStatus = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.liveStatus.add, payload);
};

const AddLiveStatusMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addLiveStatus, {
        onSuccess: () => {
            queryClient.invalidateQueries('LiveStatuses');
            toastMessage('success', 'Live Status Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            toastMessage('error', desc || 'Server Error');
        }
    });
};

const deleteLiveStatus = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.liveStatus.delete + id);
};

const DeleteLiveStatusMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteLiveStatus, {
        onSuccess: () => {
            queryClient.invalidateQueries('LiveStatuses');
            toastMessage('success', 'Live Status Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            toastMessage('error', desc || 'Server Error');
        }
    });
};

export { GetAllLiveStatuses, AddLiveStatusMutation, DeleteLiveStatusMutation };
